import React from "react";

import ParallaxImage from "../ParallaxImage";
import { ReactLenis } from "@studio-freight/react-lenis";
import "../../css/SelectionBg.css";
import InteriorDesignResidentialSelectionComponent from "../InteriorDesignComponents/InteriorDesignResidentialSelection";
import LuxeSelection from "../Selection2/LuxeSelection";
import BeysuSelection from "../Selection2/BeysuSelection";
import MagellanSelection from "../Selection2/MagellanSelection";
import MagellanShow from "../CommercialComponents/commercialimagesshow/MagellanShow";
import DawlanceSelection from "../Selection2/DawlanceSelection";
import AzelSelection from "../Selection2/AzelSelection";
import ExternalSlider from "./ExternalSlider";
import CoastalSelection from "../Selection2/CoastalSelection";
import ModernHarmonySelection from "../Selection2/ModernHarmonySelection";
import ModernHarmonyShow from "./ExteriorImageShow/ModernHarmonyShow";

export default function ModernHarmonyComponent() {
  return (
    <ReactLenis root>
      <div className="app1">
        <section className="hero">
          <div className="img">
            <ParallaxImage
              src="../../Images/exteriorimages/2-ModernHarmonyVilla/a/1.jpg"
              alt=""
            />
          </div>

          <div className="nav">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingTop: "200px",
              }}
            >
              <p className="p5">Modern Harmony Villa</p>
              {/* <p>COMMERCIAL INTERIOR DESIGN</p>
              <p>EXTERIOR DESIGN</p> */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  paddingLeft: "10px",
                  color: "#e7e7e7",
                  textTransform: "uppercase",
                  fontSize: "20px",
                }}
              >
                <span>role in project: 3d drawings</span>
                <span>project duration: 2 weeks</span>
                <span>year of completion: 2023</span>
                <span>project location:Cankaya, Ankara-TURKIYE</span>
              </div>
            </div>
          </div>
        </section>

        <section className="projects">
          <div className="img">
            <ParallaxImage
              src="../../Images/exteriorimages/2-ModernHarmonyVilla/c/10.jpg"
              alt=""
            />
          </div>

          {/* <div className="projects-brief">
              <p
                style={{
                    color:"black",
                    fontSize:"30px"
                }}
              >
              This modern living space and bedroom are designed to inspire with its elegant lines, warm tones, and luxurious finishes, creating an inviting ambiance for both relaxation and entertaining.
              </p>
            </div> */}

          <div className="col projects-cover">
            <div
              className="img"
              style={{
                marginTop: "1000px",
                zIndex: "9999",
              }}
            >
              <ParallaxImage
                src="../../Images/exteriorimages/2-ModernHarmonyVilla/c/11.jpg"
                alt=""
              />
            </div>
          </div>

          <div className="col projects-list">
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                Modern
                <br />
                Elegance
              </h1>
            </div>
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                Meets
                <br />
                Functional
              </h1>
            </div>
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                Outdoor
                <br />
                Living
              </h1>
            </div>
          </div>
        </section>

        <section className="projects">
          <div className="img">
            <ParallaxImage src="../../Images/Untitled.png" alt="" />
          </div>

          <div className="projects-brief">
            <p
              style={{
                color: "#dbccc0",

                paddingLeft: "350px",
                width: "800px",
                fontSize: "35px",
                textAlign: "left",
              }}
            >
              "Blending sleek minimalism with functional outdoor spaces, this
              modern residential design combines bold architectural lines,
              contemporary lighting, and thoughtfully landscaped areas to create
              a sophisticated yet comfortable environment that emphasizes both
              privacy and relaxation."
            </p>
          </div>

          <div className="col projects-cover">
            <div className="img" style={{}}>
              <ParallaxImage
                src="../../Images/exteriorimages/2-ModernHarmonyVilla/c/11.jpg"
                alt=""
              />
            </div>
          </div>

          <div
            className="col projects-list"
            style={{
              opacity: "0",
            }}
          >
            <div className="project">
              <h1>
                Modern
                <br />
                Elegance
              </h1>
            </div>
            <div className="project">
              <h1>
                Meets
                <br />
              </h1>
            </div>
            <div className="project">
              <h1>Comfort</h1>
            </div>
            <div className="project">
              <h1>2024</h1>
            </div>
          </div>
        </section>

        <section className="about">
          <div className="col intro">
            <p>ABOUT</p>
            <p
              style={{
                width: "500px",
              }}
            >
              This project showcases a modern architectural design for a
              residential property that combines sleek minimalism with
              functional outdoor spaces. The façade features clean lines,
              contemporary lighting details, and an emphasis on symmetry,
              creating a bold and sophisticated look.
              <br />
              <br />
              The landscaped area highlights geometric pathways, water features
              with reflective spheres, and greenery to enhance the ambiance. The
              backyard design includes cozy seating arrangements, accent
              lighting, and a balance of natural and built elements, offering
              both privacy and relaxation.
              <br />
              <br />
              This project reflects a thoughtful integration of aesthetics and
              practicality, tailored for a lifestyle that appreciates
              simplicity, elegance, and comfort.
            </p>
          </div>
          <div className="col portrait">
            <div className="portrait-container">
              <div className="img">
                <ParallaxImage
                 src="../../Images/exteriorimages/2-ModernHarmonyVilla/d/13.jpg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </section>

        <section className="banner">
          <ModernHarmonySelection />
        </section>

        <section className="banner">
          <div className="img">
            <ParallaxImage
               src="../../Images/exteriorimages/2-ModernHarmonyVilla/e/18b.jpg"
              alt=""
            />
          </div>

          {/* <div className="banner-copy">
              <p
              
              >Location:</p>
              <h1
                style={{
                    color:"#1a1a1a"
                }}
              >Yenimahalle, </h1>
             <h1
               style={{
                color:"#1a1a1a"
            }}
             >Ankara-TURKIYE</h1>
            
            </div> */}
        </section>

        {/* <section className="footer1">
          <div className="col">
            <p>Instagram</p>

            <div className="footer-links">
              <p>Luxe Residance</p>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                "A Perfect Blend
              </h1>
              <h1> of Style and Comfort."</h1>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                A2Z Design & Build
              </h1>
            </div>
          </div>

       
          <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div>
        </section> */}

        <section className="footer2">
          <div className="col2">
            <div className="footer-links">
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "40px",
                }}
              >
                “Contemporary elegance blended with tranquil outdoor charm.”
              </h1>
              <p>A2Z Design Studio</p>
            </div>
          </div>

          {/* <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div> */}
        </section>
        <ModernHarmonyShow/>
        <ExternalSlider />
      </div>
    </ReactLenis>
  );
}
